<template>
  <base-page>
    <el-card style="margin: 5px 0px 5px 0px;">
      <el-collapse accordion style="border: none;">
        <el-collapse-item name="1" style="border: none">
          <template slot="title">
            <div style="display:flex;align-items:center" slot="header" class="clearfix">
              <titlu-pagina
                Titlu="Zile libere"
                @on_add_clicked="show_dialog()"
                :AdaugaVisible="true"
              />
              <div>
                <el-tooltip content="Adauga un interval de zile libere" effect="light">
                  <el-button @click.stop.prevent @click="show_dialog_multiple_days()" size="small" circle icon="el-icon-files"></el-button>
                </el-tooltip>
              </div>
            </div>
          </template>
      <div class="filtre">
        <el-form @submit.prevent.native="refresh_info()">
          <el-row style="margin: 10px" class="input-group">
            <el-col class="input-element">
              <el-form-item label="Denumire">
                <el-input v-model="Filters.Denumire" size="small"/>
              </el-form-item>
            </el-col>
            <el-col class="input-element">
              <el-form-item label="Angajat">
                <el-select class="full-width" v-model="Filters.IdUtilizator" filterable size="small">
                  <el-option label="Toti" value="-1"></el-option>
                  <el-option
                    v-for="item in Info.utilizatori"
                    :key="'utilizatori' + item.Id"
                    :label="item.Nume"
                    :value="item.Id"
                  ></el-option>
              </el-select>
              </el-form-item>
            </el-col>

            <el-col class="input-element">
              <el-form-item label='Interval'>
                <br>
                <el-date-picker
                    v-model="Filters.Data"
                    type="daterange" size="small"
                    range-separator="-"
                    start-placeholder="Data inceput"
                    end-placeholder="Data sfarsit"
                    :picker-options="datePickerOptions"
                    format="dd/MM/yyyy" value-format="yyyy-MM-dd" >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :md="24">
              <el-button
                type="primary" size="small"
                native-type="submit"
                @click="refresh_info()"
              >
                Aplica
              </el-button>

              <el-button type="danger" native-type="submit" @click="reset()" size="small">
                Reseteaza
              </el-button>
            </el-col>
          </el-row>
        </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>

    <el-table :data="Results">
      <el-table-column prop="Id" label="#" width="80px"></el-table-column>
      <el-table-column prop="Denumire" label="Denumire"></el-table-column>
      <el-table-column prop="NumeUtilizator" label="Angajat(i)"></el-table-column>
      <el-table-column label="Data" width = "150px">
        <template slot-scope="scope">
          {{ scope.row.ZiLibera | DataRo() }}
        </template> 
      </el-table-column>
      <el-table-column label="Interval orar">
        <template slot-scope="scope">
          <span v-if="!scope.row.IntervalOrarLiber">Toata ziua</span>
          <div v-else>
            <el-time-picker
              :prefix-icon="''"
              :readonly=true size="small"
              v-model="scope.row.IntervalOrarLiber"
              is-range
              value-format = "HH:mm:00"
              format = "HH:mm"
              clearable
              range-separator="-"
            />
          </div>
        </template> 
      </el-table-column>
      <el-table-column fixed="right" label="Actiuni" width="110px">
        <template slot-scope="scope">
          <el-tooltip content="Modificare">
            <el-button
              type="primary"
              icon="el-icon-edit"
              circle size="small"
              @click="show_dialog(scope.row.Id)"
            />
          </el-tooltip>

          <el-tooltip content="Sterge">
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle size="small"
              @click="delete_item(scope.row)"
            /> 
          </el-tooltip>
        </template>
      </el-table-column
    ></el-table>
    <el-pagination
      @size-change="refresh_info"
      @current-change="refresh_info"
      :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page"
      :total="PaginationInfo.RowCount"
      layout="pager" />
    <Utilizatori-zile-libere-dialog class="custom-width" ref="dlg" @save="refresh_info()"/>
    <Utilizatori-zile-libere-interval-dialog class="custom-width" ref="dlgInterval" @save="refresh_info()" />
  </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import Utilizatori_zile_libere_dialog from "@/pages/Admin/utilizatori_zile_libere/Utilizatori_zile_libere_dialog.vue";
import Utilizatori_zile_libere_interval_dialog from "@/pages/Admin/utilizatori_zile_libere/Utilizatori_zile_libere_interval_dialog.vue";
import TitluPagina from "@/widgets/TitluPagina";

export default {
  name: "marci_masini",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "Utilizatori-zile-libere-dialog": Utilizatori_zile_libere_dialog,
    "Utilizatori-zile-libere-interval-dialog": Utilizatori_zile_libere_interval_dialog,
    "titlu-pagina": TitluPagina,
  },
  data() {
    return {
      datePickerOptions: settings.datePickerOptions,
      Results: [],
      base_url: "",
      Info: {},
      Filters: {
        Denumire: "",
        Data: [],
        IdUtilizator: "-1",
      },
      OrderBy: {},
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
    };
  },

  
  methods: {
    async get_info() {
      var response = await this.post("utilizatori/get_info_zile_libere");
      this.Info.utilizatori = response.utilizatori;
     this.refresh_info();
    },


    async refresh_info() {
      var response = await this.post("utilizatori/index_zile_libere", {
        Filters: this.Filters,
        OrderBy: this.OrderBy,
        PaginationInfo: this.PaginationInfo,
      });
      this.Results = response.Results;
      this.PaginationInfo = response.PaginationInfo;
      //
      this.select_menu_item("zile_libere");
    },
    show_dialog_multiple_days(){
      this.$refs.dlgInterval.show_me();
    },
    reset() {
      this.Filters = {
        Denumire: "",
        Data: [],
        IdUtilizator: "-1",
      };
      this.refresh_info();
    },

    async delete_item(item) {
      var confirm = await this.$confirm(`Sunteti sigur ?`, "Warning");
      if (confirm) {
        await this.post("utilizatori/delete_item_zile_libere", { id: item.Id });
        this.refresh_info();
      }
    },

    show_dialog(id) {
      this.$refs.dlg.show_me(id);
    },
  },
  mounted() {
    if (!this.$has_right("Management")) {
      this.$router.push("/no-rights");
      return;
    }
    this.base_url = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}

.input-element {
  width: 31%;
  margin-right: 2%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;
  }

  .el-tooltip__popper {
    width: 90%;
  }  


}
</style>
